<div>
  <iframe #paymentWidget id="paymentWidget"
          width="100%"
          height="500"
          [src]="safeUrl"></iframe>
</div>
